import { createConnection } from '../redux/api';

// One owner per customer tab/session. Page subscribers never stop the transport.
export function startTableSessionConnection(session, onEvent, factory = createConnection) {
  let connection;
  let disposed = false;
  let busy = false;
  let retryTimer;
  let failures = 0;
  const handlers = {};
  const schedule = () => {
    if (disposed || retryTimer) return;
    retryTimer = setTimeout(() => {
      retryTimer = undefined;
      connect();
    }, Math.min(2000 * 2 ** Math.min(failures++, 4), 30000));
  };
  const connect = async () => {
    if (disposed || busy) return;
    busy = true;
    try {
      if (!connection) {
        connection = await factory();
        if (disposed) return;
        ['ReceiveBillStatus', 'ReceiveLiveBillModification'].forEach(event => {
          handlers[event] = data => { if (!disposed) onEvent(event, data); };
          connection.on(event, handlers[event]);
        });
        connection.onreconnected(() => { connect(); });
        connection.onclose(() => { schedule(); });
      }
      if (connection.state === 'Disconnected') await connection.start();
      if (disposed) { await connection.stop(); return; }
      if (connection.state !== 'Connected') { schedule(); return; }
      await connection.invoke('JoinTableSessionGroup',
        String(session.restaurantId).trim().toLowerCase(), String(session.tableOtp).trim());
      clearTimeout(retryTimer);
      retryTimer = undefined;
      failures = 0;
    } catch (error) {
      if (!disposed) {
        console.warn('Table session connection/join failed; retrying.', error);
        schedule();
      }
    } finally { busy = false; }
  };
  connect();
  return () => {
    disposed = true;
    clearTimeout(retryTimer);
    if (connection) {
      for (const [event, handler] of Object.entries(handlers)) connection.off(event, handler);
      connection.stop().catch(error => console.warn('Table session stop failed.', error));
    }
  };
}
